import React, { Fragment, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { H6 } from "../../../AbstractElements";
import { Calendar, Clipboard, CreditCard, File, Layers } from "react-feather";
import { Link } from "react-router-dom";
import useAxios from "../../../Utils/useAxios";
import ModalUMO from "../../Uang Muka/Operasional/components/CreateUMOModal";
// import ModalDaftarAkun from "../../DaftarAkun/ModalDaftarAkun";
import CollapseableCard from "../../../CommonElements/Collapse/CollapseableCard";
import { FEATURE_FUNCTION_SELECTION } from "../../../Constant/FeatureSelection";
import getUnitKerja from "../services/getUnitKerja";
import getUMO from "../services/getUMO";
import getRencImp from "../services/getRencImpAkun";
import getKegiatan from "../services/getKeigatan";
import getDaftarAkun from "../services/getDaftarAkun";
import quickOptionData from "../constants/quickOptionData";
import getRencImpAkun from "../services/getRencImpAkun";
import ModalDaftarAkun from "../../DaftarAkun/components/ModalDaftarAkun";

const QuickOption = (props) => {
  const axiosInstance = useAxios();
  const [UMOList, setUMOList] = useState([]);
  const [rencImpList, setRencImpList] = useState([]);
  const [unitKerja, setUnitKerja] = useState([]);
  const [kegiatan, setKegiatan] = useState([]);
  const [daftarAkun, setDaftarAkun] = useState([]);
  const [total, setTotal] = useState(0);

  const [createUMOOpen, setCreateUMOOpen] = useState(false);
  const toggleUMO = () => setCreateUMOOpen(!createUMOOpen);

  const [modalCreateAkunOpen, setModalCreateAkunOpen] = useState(false);
  const toggleModalCreateAkun = () =>
    setModalCreateAkunOpen(!modalCreateAkunOpen);

  let isMounted = true;
  useEffect(() => {
    refreshUnitKerja();
    refreshUMO();
    refreshRencImp();
    refreshKegiatan();
    refreshDaftarAkun();

    return () => {
      isMounted = false;
    };
  }, []);

  const refreshUnitKerja = () => {
    getUnitKerja(axiosInstance).then((response) => {
      if (isMounted && response.status === 200) {
        setUnitKerja(response.data);
      } else {
        console.log("Error when fetching data");
      }
    });
  };

  const refreshUMO = async () => {
    getUMO(axiosInstance).then((res) => {
      if (isMounted) {
        setUMOList(res.data);
        calculateTotal(res.data);
      }
    })
  };

  const refreshRencImp = async () => {
    getRencImpAkun(axiosInstance).then((response) => {
      if (isMounted) {
        setRencImpList(response.data);
      }
    });
  };

  const refreshKegiatan = async () => {
    getKegiatan(axiosInstance).then((response) => {
      if (isMounted) {
        setKegiatan(response.data);
      }
    });
  };

  const refreshDaftarAkun = async () => {
    getDaftarAkun(axiosInstance).then((response) => {
      if (isMounted) {
        setDaftarAkun(response.data);
      }
    });
  };

  const calculateTotal = (data) => {
    let sum = data.reduce((acc, cur) => acc + parseInt(cur.nilai), 0);
    setTotal(sum);
  };

  return (
    <Fragment>
      <Col {...props}>
        <CollapseableCard title={"Pilihan Cepat"}>
          <Row className="options-main justify-content-evenly text-center">
            {quickOptionData.map((item) => {
              const button = (
                <div className="option-box btn-outline-primary rounded-2 h-75 d-inline-block align-content-center">
                  {item.icon}
                  <H6>{item.title}</H6>
                </div>
              );
              return (
                item.feature && (
                  <div className="col-2" key={item.id}>
                    {item.id === 3 ? (
                      <a onClick={toggleModalCreateAkun} role="button">
                        {button}
                      </a>
                    ) : item.id === 4 ? (
                      <a onClick={toggleUMO} role="button">
                        {button}
                      </a>
                    ) : (
                      <Link to={item.path}>{button}</Link>
                    )}
                  </div>
                )
              );
            })}
          </Row>
        </CollapseableCard>

        <ModalDaftarAkun
          getRencImp={getRencImp}
          unitKerja={unitKerja}
          kegiatan={kegiatan}
          daftarAkun={daftarAkun}
          modal={modalCreateAkunOpen}
          toggle={toggleModalCreateAkun}
        />
        <ModalUMO
          getUMO={getUMO}
          unitKerja={unitKerja}
          modal={createUMOOpen}
          toggle={toggleUMO}
          UMOList={UMOList}
        />
      </Col>
    </Fragment>
  );
};
export default QuickOption;
